import { render, staticRenderFns } from "./yjsfc.vue?vue&type=template&id=ba5601c4&scoped=true"
import script from "./yjsfc.vue?vue&type=script&lang=js"
export * from "./yjsfc.vue?vue&type=script&lang=js"
import style0 from "./yjsfc.vue?vue&type=style&index=0&id=ba5601c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5601c4",
  null
  
)

export default component.exports